import { render, staticRenderFns } from "./StripeCheckout.vue?vue&type=template&id=b1b6a158&"
import script from "./StripeCheckout.vue?vue&type=script&lang=js&"
export * from "./StripeCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports